import { render, staticRenderFns } from "./LimitedOffer.vue?vue&type=template&id=0d1dba14&"
import script from "./LimitedOffer.vue?vue&type=script&lang=js&"
export * from "./LimitedOffer.vue?vue&type=script&lang=js&"
import style0 from "./LimitedOffer.vue?vue&type=style&index=0&id=0d1dba14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports